"use client";

import { usePathname } from "next/navigation";
import Logo from "@/components/brand/Logo";
import { isChromelessRoute } from "@/config/layout-config";
import { cn } from "@/lib/utils";

export default function Loading() {
	const pathname = usePathname();
	const isChromeless = isChromelessRoute(pathname);

	return (
		<div
			className={cn(
				"flex w-full items-center justify-center bg-background",
				isChromeless
					? "min-h-dvh"
					: "min-h-[calc(100dvh-4.5rem)] md:min-h-[calc(100dvh-5rem)]",
			)}
		>
			<Logo
				variant="logo"
				size="xl"
				className="mb-10 animate-pulse text-3xl opacity-80 transition-opacity"
			/>
		</div>
	);
}
